
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as indexLhLEN2FbTiUuq_suBbxac0UMI_45IwhSv6IlNhcnlFdm4Meta } from "/app/pages/user-zone/index.vue?macro=true";
import { default as profilerVmhy4UV8uCUrGsnK1MUI9_45zo3A39jP_45KDKEu8E0_OkMeta } from "/app/pages/user-zone/profile.vue?macro=true";
import { default as bookingscfcHaF87S6y6Ua7UMlKVdfDlWEFn5egVKxRhcQpwkeQMeta } from "/app/pages/user-zone/bookings.vue?macro=true";
import { default as favoritesOsWUX7sbAS3JNEJsMOQ_9RkbE__455F1SCzXLVRTvVOHMMeta } from "/app/pages/user-zone/favorites.vue?macro=true";
import { default as user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta } from "/app/pages/user-zone.vue?macro=true";
import { default as destinationsvsU5q4nXUvdzk8ba8jFGAsIsyeWkYSIgtBQUNoZN9MMMeta } from "/app/pages/destinations.vue?macro=true";
import { default as loginehDr_41jwecbTd4tzIisUOscIkaEghB0qHLyoD4u4UcMeta } from "/app/pages/(login)/login.vue?macro=true";
import { default as recover960sZB7Jq4ghWdkNSuE7Aae_45fC3qfCKlOit8H_jQ92UMeta } from "/app/pages/(login)/recover.vue?macro=true";
import { default as registerSLfVUo60_Iscx_45rQGGqSKg_45UmPNAXjf6ccI6SRreub0Meta } from "/app/pages/(login)/register.vue?macro=true";
import { default as _91city_93_45_91id_93_46htmlOVYho4ajyvuIbsq321zJ2KFgIC2tiZ0k8hc3zrE7TtsMeta } from "/app/pages/[city]-[id].html.vue?macro=true";
import { default as _91hotel_93_45_91id_93_46htmljHSBt9MV00PQr0EJhaE2g7P97Q0QgjTu_45U_45dTNOym8IMeta } from "/app/pages/[hotel]-[id].html.vue?macro=true";
import { default as como_45funciona_46htmlbBqW3yKoi_9EcHNSRA__45f4snEPuIo6jzbZ_45_45dYz1VncMeta } from "/app/pages/como-funciona.html.vue?macro=true";
import { default as _91landing_93_45_91id_93_46htmlsgCWqRFLaZFX45DaRp9F9sfLwG76Oon9YbW9_45ysOdaEMeta } from "/app/pages/[landing]-[id].html.vue?macro=true";
import { default as _91hash_93QKWMMof_m5B2vBfv56RVE7N1iPHytLBqZgM350nEJMgMeta } from "/app/pages/(login)/recover-pass/[hash].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "search___es",
    path: "/es/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___it",
    path: "/it/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta?.name,
    path: "/es/user-zone",
    meta: { ...(user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___es",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___es",
    path: "profile",
    component: () => import("/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___es",
    path: "bookings",
    component: () => import("/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___es",
    path: "favorites",
    component: () => import("/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta?.name,
    path: "/en/user-zone",
    meta: { ...(user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___en",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___en",
    path: "profile",
    component: () => import("/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___en",
    path: "bookings",
    component: () => import("/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___en",
    path: "favorites",
    component: () => import("/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta?.name,
    path: "/de/user-zone",
    meta: { ...(user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___de",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___de",
    path: "profile",
    component: () => import("/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___de",
    path: "bookings",
    component: () => import("/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___de",
    path: "favorites",
    component: () => import("/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta?.name,
    path: "/it/user-zone",
    meta: { ...(user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___it",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___it",
    path: "profile",
    component: () => import("/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___it",
    path: "bookings",
    component: () => import("/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___it",
    path: "favorites",
    component: () => import("/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta?.name,
    path: "/fr/user-zone",
    meta: { ...(user_45zone_bWQazfN8c_PgsuvljEkG2YJ6JJCl5xAbZ5f_JlFO_45MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___fr",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___fr",
    path: "profile",
    component: () => import("/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___fr",
    path: "bookings",
    component: () => import("/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___fr",
    path: "favorites",
    component: () => import("/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: "destinations___es",
    path: "/es/destinations",
    component: () => import("/app/pages/destinations.vue")
  },
  {
    name: "destinations___en",
    path: "/en/destinations",
    component: () => import("/app/pages/destinations.vue")
  },
  {
    name: "destinations___de",
    path: "/de/destinations",
    component: () => import("/app/pages/destinations.vue")
  },
  {
    name: "destinations___it",
    path: "/it/destinations",
    component: () => import("/app/pages/destinations.vue")
  },
  {
    name: "destinations___fr",
    path: "/fr/destinations",
    component: () => import("/app/pages/destinations.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: loginehDr_41jwecbTd4tzIisUOscIkaEghB0qHLyoD4u4UcMeta || {},
    component: () => import("/app/pages/(login)/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginehDr_41jwecbTd4tzIisUOscIkaEghB0qHLyoD4u4UcMeta || {},
    component: () => import("/app/pages/(login)/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: loginehDr_41jwecbTd4tzIisUOscIkaEghB0qHLyoD4u4UcMeta || {},
    component: () => import("/app/pages/(login)/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    meta: loginehDr_41jwecbTd4tzIisUOscIkaEghB0qHLyoD4u4UcMeta || {},
    component: () => import("/app/pages/(login)/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: loginehDr_41jwecbTd4tzIisUOscIkaEghB0qHLyoD4u4UcMeta || {},
    component: () => import("/app/pages/(login)/login.vue")
  },
  {
    name: "recover___es",
    path: "/es/recover",
    meta: recover960sZB7Jq4ghWdkNSuE7Aae_45fC3qfCKlOit8H_jQ92UMeta || {},
    component: () => import("/app/pages/(login)/recover.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: recover960sZB7Jq4ghWdkNSuE7Aae_45fC3qfCKlOit8H_jQ92UMeta || {},
    component: () => import("/app/pages/(login)/recover.vue")
  },
  {
    name: "recover___de",
    path: "/de/recover",
    meta: recover960sZB7Jq4ghWdkNSuE7Aae_45fC3qfCKlOit8H_jQ92UMeta || {},
    component: () => import("/app/pages/(login)/recover.vue")
  },
  {
    name: "recover___it",
    path: "/it/recover",
    meta: recover960sZB7Jq4ghWdkNSuE7Aae_45fC3qfCKlOit8H_jQ92UMeta || {},
    component: () => import("/app/pages/(login)/recover.vue")
  },
  {
    name: "recover___fr",
    path: "/fr/recover",
    meta: recover960sZB7Jq4ghWdkNSuE7Aae_45fC3qfCKlOit8H_jQ92UMeta || {},
    component: () => import("/app/pages/(login)/recover.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: registerSLfVUo60_Iscx_45rQGGqSKg_45UmPNAXjf6ccI6SRreub0Meta || {},
    component: () => import("/app/pages/(login)/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerSLfVUo60_Iscx_45rQGGqSKg_45UmPNAXjf6ccI6SRreub0Meta || {},
    component: () => import("/app/pages/(login)/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registerSLfVUo60_Iscx_45rQGGqSKg_45UmPNAXjf6ccI6SRreub0Meta || {},
    component: () => import("/app/pages/(login)/register.vue")
  },
  {
    name: "register___it",
    path: "/it/register",
    meta: registerSLfVUo60_Iscx_45rQGGqSKg_45UmPNAXjf6ccI6SRreub0Meta || {},
    component: () => import("/app/pages/(login)/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registerSLfVUo60_Iscx_45rQGGqSKg_45UmPNAXjf6ccI6SRreub0Meta || {},
    component: () => import("/app/pages/(login)/register.vue")
  },
  {
    name: "city-id.html___es",
    path: "/es/:city-:id(\\d+[dn]).html",
    meta: _91city_93_45_91id_93_46htmlOVYho4ajyvuIbsq321zJ2KFgIC2tiZ0k8hc3zrE7TtsMeta || {},
    component: () => import("/app/pages/[city]-[id].html.vue")
  },
  {
    name: "city-id.html___en",
    path: "/en/:city-:id(\\d+[dn]).html",
    meta: _91city_93_45_91id_93_46htmlOVYho4ajyvuIbsq321zJ2KFgIC2tiZ0k8hc3zrE7TtsMeta || {},
    component: () => import("/app/pages/[city]-[id].html.vue")
  },
  {
    name: "city-id.html___de",
    path: "/de/:city-:id(\\d+[dn]).html",
    meta: _91city_93_45_91id_93_46htmlOVYho4ajyvuIbsq321zJ2KFgIC2tiZ0k8hc3zrE7TtsMeta || {},
    component: () => import("/app/pages/[city]-[id].html.vue")
  },
  {
    name: "city-id.html___it",
    path: "/it/:city-:id(\\d+[dn]).html",
    meta: _91city_93_45_91id_93_46htmlOVYho4ajyvuIbsq321zJ2KFgIC2tiZ0k8hc3zrE7TtsMeta || {},
    component: () => import("/app/pages/[city]-[id].html.vue")
  },
  {
    name: "city-id.html___fr",
    path: "/fr/:city-:id(\\d+[dn]).html",
    meta: _91city_93_45_91id_93_46htmlOVYho4ajyvuIbsq321zJ2KFgIC2tiZ0k8hc3zrE7TtsMeta || {},
    component: () => import("/app/pages/[city]-[id].html.vue")
  },
  {
    name: "hotel-id.html___es",
    path: "/es/:hotel-:id(\\d+).html",
    meta: _91hotel_93_45_91id_93_46htmljHSBt9MV00PQr0EJhaE2g7P97Q0QgjTu_45U_45dTNOym8IMeta || {},
    component: () => import("/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "hotel-id.html___en",
    path: "/en/:hotel-:id(\\d+).html",
    meta: _91hotel_93_45_91id_93_46htmljHSBt9MV00PQr0EJhaE2g7P97Q0QgjTu_45U_45dTNOym8IMeta || {},
    component: () => import("/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "hotel-id.html___de",
    path: "/de/:hotel-:id(\\d+).html",
    meta: _91hotel_93_45_91id_93_46htmljHSBt9MV00PQr0EJhaE2g7P97Q0QgjTu_45U_45dTNOym8IMeta || {},
    component: () => import("/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "hotel-id.html___it",
    path: "/it/:hotel-:id(\\d+).html",
    meta: _91hotel_93_45_91id_93_46htmljHSBt9MV00PQr0EJhaE2g7P97Q0QgjTu_45U_45dTNOym8IMeta || {},
    component: () => import("/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "hotel-id.html___fr",
    path: "/fr/:hotel-:id(\\d+).html",
    meta: _91hotel_93_45_91id_93_46htmljHSBt9MV00PQr0EJhaE2g7P97Q0QgjTu_45U_45dTNOym8IMeta || {},
    component: () => import("/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "como-funciona.html___es",
    path: "/es/como-funciona.html",
    component: () => import("/app/pages/como-funciona.html.vue")
  },
  {
    name: "como-funciona.html___en",
    path: "/en/como-funciona.html",
    component: () => import("/app/pages/como-funciona.html.vue")
  },
  {
    name: "como-funciona.html___de",
    path: "/de/como-funciona.html",
    component: () => import("/app/pages/como-funciona.html.vue")
  },
  {
    name: "como-funciona.html___it",
    path: "/it/como-funciona.html",
    component: () => import("/app/pages/como-funciona.html.vue")
  },
  {
    name: "como-funciona.html___fr",
    path: "/fr/como-funciona.html",
    component: () => import("/app/pages/como-funciona.html.vue")
  },
  {
    name: "landing-id.html___es",
    path: "/es/:slug-:id(\\d+l).html",
    meta: _91landing_93_45_91id_93_46htmlsgCWqRFLaZFX45DaRp9F9sfLwG76Oon9YbW9_45ysOdaEMeta || {},
    component: () => import("/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "landing-id.html___en",
    path: "/en/:slug-:id(\\d+l).html",
    meta: _91landing_93_45_91id_93_46htmlsgCWqRFLaZFX45DaRp9F9sfLwG76Oon9YbW9_45ysOdaEMeta || {},
    component: () => import("/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "landing-id.html___de",
    path: "/de/:slug-:id(\\d+l).html",
    meta: _91landing_93_45_91id_93_46htmlsgCWqRFLaZFX45DaRp9F9sfLwG76Oon9YbW9_45ysOdaEMeta || {},
    component: () => import("/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "landing-id.html___it",
    path: "/it/:slug-:id(\\d+l).html",
    meta: _91landing_93_45_91id_93_46htmlsgCWqRFLaZFX45DaRp9F9sfLwG76Oon9YbW9_45ysOdaEMeta || {},
    component: () => import("/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "landing-id.html___fr",
    path: "/fr/:slug-:id(\\d+l).html",
    meta: _91landing_93_45_91id_93_46htmlsgCWqRFLaZFX45DaRp9F9sfLwG76Oon9YbW9_45ysOdaEMeta || {},
    component: () => import("/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "recover-pass-hash___es",
    path: "/es/recover-pass/:hash()",
    meta: { ...(_91hash_93QKWMMof_m5B2vBfv56RVE7N1iPHytLBqZgM350nEJMgMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "recover-pass-hash___en",
    path: "/en/recover-pass/:hash()",
    meta: { ...(_91hash_93QKWMMof_m5B2vBfv56RVE7N1iPHytLBqZgM350nEJMgMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "recover-pass-hash___de",
    path: "/de/recover-pass/:hash()",
    meta: { ...(_91hash_93QKWMMof_m5B2vBfv56RVE7N1iPHytLBqZgM350nEJMgMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "recover-pass-hash___it",
    path: "/it/recover-pass/:hash()",
    meta: { ...(_91hash_93QKWMMof_m5B2vBfv56RVE7N1iPHytLBqZgM350nEJMgMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "recover-pass-hash___fr",
    path: "/fr/recover-pass/:hash()",
    meta: { ...(_91hash_93QKWMMof_m5B2vBfv56RVE7N1iPHytLBqZgM350nEJMgMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]